import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isAdministrator } from '../../../utils/role'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSub: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  const [isOpenSetting, setIsOpenSetting] = useState<boolean>(true)
  const [isOpenManagement, setIsOpenManagement] = useState<boolean>(true)
  const [isOpenData, setIsOpenData] = useState<boolean>(true)

  return (
    <>
      {
        location.pathname.match(URL.TASK.path)
        && login.function_enabled_state?.task_management ? (
          <div className="side_sub_wrap">
            <div className="tools">
              <div className="calendar_text">
                <div />
                <button
                  type="button"
                  className={`menu_toggle ${isOpen && "display"}`}
                  onClick={() => toggleCallback()}
                >
                  <div className={`menu ${isOpen && "active"}`}>
                    <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                  </div>
                </button>
              </div>
            </div>
            <section className="side_sub">
              <div
                className="item folder"
                onClick={() => setIsOpenData(!isOpenData)}
                role="none"
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-down']}
                    className={`arrow_icon ${isOpenData && "open"}`}
                  />
                  <div className="name_area">
                    <FontAwesomeIcon
                      icon={['fas', 'user']}
                      className="icon task"
                    />
                    あなたのデータ
                  </div>
                </div>
              </div>
              <div className={`${isOpenData || "hidden none"}`}>
                <Link
                  to={setPath(URL.TASK_LABELING_SELF.path, language)}
                  className={classNames({
                    active: location.pathname.match(URL.TASK_LABELING_SELF.path),
                    item: true,
                    indent_1: true,
                  })}
                >
                  <div className="name_label">
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="arrow_icon"
                    />
                    <div className="name_area">
                      <FontAwesomeIcon
                        icon={['fas', 'tags']}
                        className="icon task"
                      />
                      業務仕分け
                    </div>
                  </div>
                </Link>
                {
                  login.function_enabled_state.task_management_approval
                  && (
                    <Link
                      to={setPath(URL.TASK_APPROVAL_SELF.path, language)}
                      className={classNames({
                        active: location.pathname.match(URL.TASK_APPROVAL_SELF.path),
                        item: true,
                        indent_1: true,
                      })}
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-right']}
                          className="arrow_icon"
                        />
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'dove']}
                            className="icon task"
                          />
                          申請状況
                        </div>
                      </div>
                    </Link>
                  )
                }
              </div>
              {
                (login.permissions?.task_report_view
                || login.permissions?.task_approver
                || login.permissions?.task_attendance_export)
                && (
                  <>
                    <div
                      className="item folder"
                      onClick={() => setIsOpenManagement(!isOpenManagement)}
                      role="none"
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-down']}
                          className={`arrow_icon ${isOpenManagement && "open"}`}
                        />
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'user-cog']}
                            className="icon task"
                          />
                          マネジメント
                        </div>
                      </div>
                    </div>
                    <div className={`${isOpenManagement || "hidden none"}`}>
                      {
                        login.permissions?.task_report_view && (
                          <>
                            <Link
                              to={setPath(URL.TASK.path, language)}
                              className={classNames({
                                active:
                                  (location.pathname.match(URL.TASK.path) && location.pathname.split("/").length === 3)
                                  || location.pathname.match("/task/task_detail/"),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'hammer']}
                                    className="icon task"
                                  />
                                  プロジェクトレポート
                                </div>
                              </div>
                            </Link>
                            <Link
                              to={setPath(URL.TASK_CATEGORY_DETAIL.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_CATEGORY_DETAIL.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'file-alt']}
                                    className="icon task"
                                  />
                                  カテゴリーレポート
                                </div>
                              </div>
                            </Link>
                            <Link
                              to={setPath(URL.TASK_LABELING_STATUS.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_LABELING_STATUS.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'user-clock']}
                                    className="icon task"
                                  />
                                  仕分け状況
                                </div>
                              </div>
                            </Link>
                          </>
                        )
                      }
                      {
                        login.function_enabled_state.task_management_approval
                        && login.permissions?.task_approver
                        && (
                          <Link
                            to={setPath(URL.TASK_APPROVAL_STATUS.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_APPROVAL_STATUS.path),
                              item: true,
                              indent_1: true,
                            })}
                          >
                            <div className="name_label">
                              <FontAwesomeIcon
                                icon={['fas', 'angle-right']}
                                className="arrow_icon"
                              />
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'gavel']}
                                  className="icon task"
                                />
                                承認状況
                              </div>
                            </div>
                          </Link>
                        )
                      }
                      {
                        login.permissions?.task_report_view && (
                          <>
                            <Link
                              to={setPath(URL.TASK_BULK_LABELING.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_BULK_LABELING.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'bullhorn']}
                                    className="icon task"
                                  />
                                  一括仕分け
                                </div>
                              </div>
                            </Link>
                          </>
                        )
                      }
                      {
                        (login.permissions?.task_report_view
                        || login.permissions?.task_attendance_export)
                        && (
                          <>
                            <Link
                              to={setPath(URL.TASK_CSV_EXPORT.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_CSV_EXPORT.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'file-csv']}
                                    className="icon task"
                                  />
                                  データエクスポート
                                </div>
                              </div>
                            </Link>
                          </>
                        )
                      }
                    </div>
                  </>
                )
              }
              {
                (
                  isAdministrator(login.role)
                  || login.permissions?.task_member_cost_setting
                  || login.permissions?.task_project_cost_setting
                  || login.permissions?.task_project_setting
                  || login.permissions?.task_project_member_setting
                ) && (
                  <>
                    <div
                      className="item folder"
                      onClick={() => setIsOpenSetting(!isOpenSetting)}
                      role="none"
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-down']}
                          className={`arrow_icon ${isOpenSetting && "open"}`}
                        />
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', 'cogs']}
                            className="icon task"
                          />
                          設定
                        </div>
                      </div>
                    </div>
                    <div className={`${isOpenSetting || "hidden none"}`}>
                      {
                        (
                          login.permissions?.task_project_setting
                          || login.permissions?.task_project_member_setting
                        ) && (
                          <>
                            <Link
                              to={setPath(URL.TASK_LABEL_SETTING.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_LABEL_SETTING.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'tasks']}
                                    className="icon task"
                                  />
                                  プロジェクト設定
                                </div>
                              </div>
                            </Link>
                            {
                              login.permissions.high_volume || (
                                <Link
                                  to={setPath(URL.TASK_LABEL_ORDER_SETTING.path, language)}
                                  className={classNames({
                                    active: location.pathname.match(URL.TASK_LABEL_ORDER_SETTING.path),
                                    item: true,
                                    indent_1: true,
                                  })}
                                >
                                  <div className="name_label">
                                    <FontAwesomeIcon
                                      icon={['fas', 'angle-right']}
                                      className="arrow_icon"
                                    />
                                    <div className="name_area">
                                      <FontAwesomeIcon
                                        icon={['fas', 'random']}
                                        className="icon task"
                                      />
                                      プロジェクト並び替え
                                    </div>
                                  </div>
                                </Link>
                              )
                            }
                          </>
                        )
                      }
                      {
                        (
                          login.permissions?.task_project_setting
                        ) && (
                          <>
                            <Link
                              to={setPath(URL.TASK_PROJECT_CATEGORY.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_PROJECT_CATEGORY.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'layer-group']}
                                    className="icon task"
                                  />
                                  カテゴリー設定
                                </div>
                              </div>
                            </Link>
                            <Link
                              to={setPath(URL.TASK_MASTER.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_MASTER.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'cog']}
                                    className="icon task"
                                  />
                                  業務設定
                                </div>
                              </div>
                            </Link>
                            <Link
                              to={setPath(URL.TASK_TARGET_SERVICE_SETTING.path, language)}
                              className={classNames({
                                active: location.pathname.match(URL.TASK_TARGET_SERVICE_SETTING.path),
                                item: true,
                                indent_1: true,
                              })}
                            >
                              <div className="name_label">
                                <FontAwesomeIcon
                                  icon={['fas', 'angle-right']}
                                  className="arrow_icon"
                                />
                                <div className="name_area">
                                  <FontAwesomeIcon
                                    icon={['fas', 'icons']}
                                    className="icon task"
                                  />
                                  仕分け対象アプリ設定
                                </div>
                              </div>
                            </Link>
                          </>
                        )
                      }
                      {
                        (
                          login.permissions?.task_member_cost_setting
                        ) && (
                          <Link
                            to={setPath(URL.TASK_COST.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_COST.path),
                              item: true,
                              indent_1: true,
                            })}
                          >
                            <div className="name_label">
                              <FontAwesomeIcon
                                icon={['fas', 'angle-right']}
                                className="arrow_icon"
                              />
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'coins']}
                                  className="icon task"
                                />
                                メンバーコスト設定
                              </div>
                            </div>
                          </Link>
                        )
                      }
                      {
                        isAdministrator(login.role) && (
                          <Link
                            to={setPath(URL.TASK_PERMISSION.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_PERMISSION.path),
                              item: true,
                              indent_1: true,
                            })}
                          >
                            <div className="name_label">
                              <FontAwesomeIcon
                                icon={['fas', 'angle-right']}
                                className="arrow_icon"
                              />
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'user-shield']}
                                  className="icon task"
                                />
                                工数管理詳細権限設定
                              </div>
                            </div>
                          </Link>
                        )
                      }
                      {
                        isAdministrator(login.role)
                        && login.function_enabled_state.task_management_approval
                        && (
                          <Link
                            to={setPath(URL.TASK_APPROVAL_SETTING.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_APPROVAL_SETTING.path),
                              item: true,
                              indent_1: true,
                            })}
                          >
                            <div className="name_label">
                              <FontAwesomeIcon
                                icon={['fas', 'angle-right']}
                                className="arrow_icon"
                              />
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['far', 'object-group']}
                                  className="icon task"
                                />
                                承認グループ設定
                              </div>
                            </div>
                          </Link>
                        )
                      }
                      {
                        (
                          isAdministrator(login.role)
                          || login.permissions?.task_project_setting
                        )
                        && (
                          <Link
                            to={setPath(URL.TASK_OTHER_SETTING.path, language)}
                            className={classNames({
                              active: location.pathname.match(URL.TASK_OTHER_SETTING.path),
                              item: true,
                              indent_1: true,
                            })}
                          >
                            <div className="name_label">
                              <FontAwesomeIcon
                                icon={['fas', 'angle-right']}
                                className="arrow_icon"
                              />
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'ellipsis-h']}
                                  className="icon task"
                                />
                                その他の設定
                              </div>
                            </div>
                          </Link>
                        )
                      }
                    </div>
                  </>
                )
              }
            </section>
          </div>
          ) : (
            <>
            </>
          )
      }
    </>
  )
}

export default SideBarSub
